import L from 'leaflet';
import $ from 'jquery';
import {getCoords, nl2brInline, getMarkerIcon} from './util';
$.fn.WebfactoryMaps = function(){
	let $map = $(this).find('[data-markers]');
	let data = $map.data();
	let states = data.states || [];
	let config = data.config || {}
	console.log({config})
	let markers = data.markers || [];
	const center = getCoords(states[0]?.pan);
	let map = L.map($map[0], {
		zoomControl: false,
		scrollWheelZoom: false, 
		dragging: false
	}).setView(center.coords,center.zoom)
	const provider = data.provider || 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png';
	function onMarkerClick(e) {
		map.eachLayer(function (layer) {
			if (layer instanceof L.Marker) {
				layer.getElement().classList.remove('marker-selected');
			}
		});
		e.target.getElement().classList.add('marker-selected');
	}
	if (provider =='google' ){
		L.tileLayer('http://{s}.google.com/vt?lyrs=r&x={x}&y={y}&z={z}',{
			maxZoom: 20,
			subdomains:['mt0','mt1','mt2','mt3']
		}).addTo(map);
	}else{
		L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
			maxZoom: 19,
		}).addTo(map);
	}

	markers = markers.map(markerData=>{
		let icon = getMarkerIcon(markerData, true,  config);
		var marker = L.marker(getCoords(markerData.pan).coords, {icon}).addTo(map);
		marker.bindPopup(`<b>${markerData.label}</b><p>${nl2brInline(markerData.descripton)??''}</p>`);
		markerData.marker = marker;
		marker.on('click', onMarkerClick)
		return markerData;
	})

	const setState = (ind)=>{
		const currentState = states[ind];
		let center = getCoords(states[ind]?.pan)
		map.flyTo({lat: center.coords[0], lng: center.coords[1]}, center.zoom)
		markers.map(m=>{
			if (m.visibility && (m.visibility!==currentState.id)){
				$(m.marker._icon).removeClass('active').addClass('inactive').find('svg').css('opacity', .1)
			} else{
				$(m.marker._icon).addClass('active').removeClass('inactive').find('svg').css('opacity', 1)

			}
		})
	}

	const id = $(this).attr('id');
	if (id){
		$(document).on('show.bs.tab', '[data-link-to="#'+id+'"]  a[data-bs-target]', function(e){
			setState($(this).parent().index())
		})
	}
}

$(document).ready(function(){
	$('.wp-block-webfactory-maps').each(function(){
		$(this).WebfactoryMaps();
	})
})
